import { useAppLocation } from '@crm/hooks/useAppLocation'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { Button, Flex, Segmented } from 'antd'
import { SegmentedProps } from 'antd/lib'
import { Add, Kanban, TextalignJustifycenter } from 'iconsax-react'
import queryString from 'query-string'

import { useParams } from 'react-router-dom'

type Props = {
  isLeadOpportunityTab?: boolean
  hideSegmented?: boolean
}

export const OpportunityHeader = ({
  hideSegmented,
  isLeadOpportunityTab
}: Props) => {
  const { id } = useParams()
  const navigate = useAppNavigate()

  const { t } = useLocales()
  const location = useAppLocation()
  const { params } = useQueryUpdate()

  const onAddOpportunity = () => {
    navigate(
      isLeadOpportunityTab && id
        ? `${paths.opportunitiesCreate}?leadId=${id}`
        : paths.opportunitiesCreate
    )
  }

  const urlParams = Object.keys(params).length
    ? `?${queryString.stringify(params)}`
    : ''

  const segmentedValue = `${location.pathname}${urlParams}`

  const segmentListValue = id
    ? `/opportunities-list/${id}${urlParams}`
    : `/opportunities${urlParams}`

  const opportunitiesKanbanSegmentValue = id
    ? `/opportunities-list/${id}/kanban${urlParams}`
    : `/opportunities/kanban${urlParams}`

  const segmentedOptions: SegmentedProps<string>['options'] = [
    {
      value: segmentListValue,
      label: <TextalignJustifycenter size={16} />
    },
    {
      value: opportunitiesKanbanSegmentValue,
      label: <Kanban size={16} />
    }
  ]

  return (
    <Flex justify="flex-end" align="start" gap={8}>
      {!!isLeadOpportunityTab && (
        <Button
          onClick={onAddOpportunity}
          icon={<Add size={16} />}
          type="primary"
        >
          {t('opportunity.add_opportunity')}
        </Button>
      )}

      {!hideSegmented && (
        <Segmented
          value={segmentedValue}
          onChange={(value) => navigate(value)}
          options={segmentedOptions}
        />
      )}
    </Flex>
  )
}
